export default "__VITE_ASSET__B1c_hMkm__"